import TableModal from './TableModal';

export default TableModal;
